function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import useFirestoreSubscribe from '@paperstac/hooks/lib/useFirestoreSubscribe';
import firestore, { getReferenceData } from '@paperstac/firebase/lib/firestore';
import * as Yup from 'yup';
import { accountByIdRef } from './accounts';
export var DAYS_GIVEN_TO_VERIFY_IDENTITY = 7;
export var MAX_NUM_OF_QUESTIONS_TO_ANSWER = 3;
export var MAX_VERIFICATION_ATTEMPTS = 3;
export var FAILED_VERIFICATION_TIMEOUT_HOURS = 24;
export var identitiesRef = function identitiesRef() {
  return firestore.collection('identities');
};
export var identityByIdRef = function identityByIdRef(identityId) {
  if (!identityId) console.log('identityByIdRef() was not given an "identityId".  Returning null...');
  return identityId ? identitiesRef().doc(identityId) : null;
};
export var identitiesByIdsRef = function identitiesByIdsRef() {
  var identityIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return identitiesRef().where('id', 'in', identityIds);
};
export var identitiesByEmailQuery = function identitiesByEmailQuery(email) {
  return identitiesRef().where('email', '==', email);
};
export var identitiesByEmailsQuery = function identitiesByEmailsQuery(emails) {
  return identitiesRef().where('email', 'in', emails);
};
export var identitiesByAccountIdRef = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(accountId) {
    var account;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getReferenceData(accountByIdRef(accountId));
          case 2:
            account = _context.sent;
            return _context.abrupt("return", identitiesByIdsRef(Object.keys(account.members)));
          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function identitiesByAccountIdRef(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var identitiesByFingerprintRef = function identitiesByFingerprintRef(fingerprint) {
  return identitiesRef().where('fingerprint', '==', fingerprint);
};
export var IDENTITY_VERIFICATION_SERVICE = {
  BLOCKSCORE: 'BLOCKSCORE',
  STRIPE: 'STRIPE'
};
export var loginValidator = function loginValidator() {
  return Yup.object().shape({
    email: Yup.string().email().required(),
    password: Yup.string().min(8).required().matches(/^(?=.*?[A-Za-z])(?=.*?[0-9])/, 'Password must contain a letter and number'),
    stayLoggedIn: Yup["boolean"]().required()
  });
};
export var sendPasswordResetEmailDispatchValidator = function sendPasswordResetEmailDispatchValidator() {
  return Yup.object().shape({
    email: Yup.string().email().required(),
    url: Yup.string()
  });
};
export var passwordResetValidator = function passwordResetValidator() {
  return Yup.object().shape({
    password: Yup.string().min(8).required().matches(/^(?=.*?[A-Za-z])(?=.*?[0-9])/, 'Password must contain a letter and number'),
    confirmPassword: Yup.string().oneOf([Yup.ref('password')], 'Passwords must match').required()
  });
};
export var createIdentityDispatchValidator = function createIdentityDispatchValidator() {
  return Yup.object().shape({
    email: Yup.string().email().required(),
    password: Yup.string().min(8).required().matches(/^(?=.*?[A-Za-z])(?=.*?[0-9])/, 'Password must contain a letter and number'),
    agreedToTerms: Yup["boolean"]().oneOf([true], 'You must agree to our terms and conditions').required()
  });
};
export var validateIdentityDispatchValidator = function validateIdentityDispatchValidator() {
  return Yup.object().shape({
    nameFirst: Yup.string().required(),
    nameMiddle: Yup.string(),
    nameLast: Yup.string().required(),
    primaryAddressStreetAddress1: Yup.string().required(),
    primaryAddressStreetAddress2: Yup.string(),
    primaryAddressCity: Yup.string().required(),
    primaryAddressState: Yup.string().when('primaryAddressCountry', {
      is: function is(val) {
        return ['US', 'CA'].includes(val);
      },
      then: Yup.string().length(2).required(),
      otherwise: Yup.string().required()
    }),
    primaryAddressZip: Yup.string().required(),
    primaryAddressCountry: Yup.string().length(2).required(),
    birthDate: Yup.string().length(10).required(),
    verificationType: Yup.string().oneOf(['ssn', 'passport']).required(),
    verificationValue: Yup.string().when('verificationType', {
      is: function is(val) {
        return val === 'ssn';
      },
      then: Yup.string().length(4).required(),
      otherwise: Yup.string().required()
    })
  });
};
export var verifyIdentityDispatchValidator = function verifyIdentityDispatchValidator() {
  return Yup.object().shape({
    id: Yup.string().required(),
    answers: Yup.array().of(Yup.object().shape({
      question_id: Yup.number().min(1).max(5).required(),
      answer_id: Yup.number().min(1).max(5).required()
    })).required()
  });
};
export var useIdentity = function useIdentity(identityId) {
  return useFirestoreSubscribe(identityByIdRef(identityId), [identityId]);
};